<template>
  <div id="contenedor-main-usuarios-contratistas">
    <template v-if="!$vuetify.breakpoint.mobile">
      <Desktop :listadoUsuariosContratistas="listadoUsuariosContratistas" />
    </template>
    <template v-else>
      <Desktop :listadoUsuariosContratistas="listadoUsuariosContratistas" />
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';

export default {
  name: 'ListadoUsuariosContratistasMain',
  props: {
    listadoUsuariosContratistas: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
